import { render, staticRenderFns } from "./create-coupons.vue?vue&type=template&id=202afda8&scoped=true"
import script from "./create-coupons.vue?vue&type=script&lang=js"
export * from "./create-coupons.vue?vue&type=script&lang=js"
import style0 from "./create-coupons.vue?vue&type=style&index=0&id=202afda8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202afda8",
  null
  
)

export default component.exports